import { render } from "./PrivateAreaHome.vue?vue&type=template&id=47f67a11&scoped=true"
import script from "./PrivateAreaHome.vue?vue&type=script&lang=js"
export * from "./PrivateAreaHome.vue?vue&type=script&lang=js"

import "./PrivateAreaHome.vue?vue&type=style&index=0&id=47f67a11&scoped=true&lang=css"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f67a11"]])

export default __exports__